import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=545f68b6"
import script from "./user-list.vue?vue&type=script&lang=ts"
export * from "./user-list.vue?vue&type=script&lang=ts"
import style0 from "./user-list.vue?vue&type=style&index=0&id=545f68b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports